import React, { useRef, useState } from "react";
import NotificacionAuth from "../NotificacionAuth/NotificacionAuth";
import { useNavigate } from "react-router-dom";
import RestablecerContraseñaEntity from "../../core/entities/restablecerContraseñaEntity";
import NotificacionEntity from "../../core/entities/notificacionEntity";
import { generarCodigoRestablecimiento } from "./service/uModalEnviarCorreoService";
import { ThreeDots } from "react-loader-spinner";

export default function UModalEnviarCorreo({
  vIsEnviarCorreo = false,
  mActivar_DesactivarModal = () => {},
}) {
  // Estado para manejar el correo electrónico y el estado de carga
  const [correo, setEmail] = useState(""); // Estado para almacenar el correo electrónico introducido
  const [vIsCargandoResp, setvIsCargandoResp] = useState(false);

  const navigate = useNavigate(); // Hook para redirigir al usuario

  const notificacionRef = useRef(null); // Referencia para manejar las notificaciones

  /**
   * Maneja el envío del formulario de restablecimiento de contraseña.
   *
   * Valida el correo electrónico ingresado, y si es válido, envía una
   * solicitud al servidor para generar un enlace de restablecimiento
   * de contraseña.
   *
   * @param {Event} event - El evento del formulario.
   */
  const handleSubmit = async (event) => {
    event.preventDefault();

    // Crear instancia de la entidad y validar
    const entidad = new RestablecerContraseñaEntity(correo);
    const errores = entidad.validar();

    if (errores.length > 0) {
      notificacionRef.current.show(
        new NotificacionEntity("Error de validación", errores[0], "rojo", 10)
      );
      return;
    }

    setvIsCargandoResp(true);
    setEmail(""); // Limpiar el campo del correo
    notificacionRef.current.hide(); // Ocultar notificaciones previas

    // Enviar la solicitud al servidor
    generarCodigoRestablecimiento(entidad)
      .then((response) => {
        setvIsCargandoResp(false);

        if (response.ok) {
          return response.json();
        }

        // Manejo de errores específicos basados en el código de estado
        switch (response.status) {
          case 500:
            return response.json().then((result) => {
              const tiempo = 15;
              switch (result.detail.acción) {
                case "CONTACTAR_SOPORTE":
                  notificacionRef.current.show(
                    new NotificacionEntity(
                      "Error del servidor",
                      result.detail.detalle,
                      "rojo",
                      tiempo
                    )
                  );
                  break;
                case "REINTENTAR_ENVIO":
                  notificacionRef.current.show(
                    new NotificacionEntity(
                      "Error al enviar el correo",
                      result.detail.detalle,
                      "amarillo",
                      tiempo
                    )
                  );
                  break;
                default:
                  notificacionRef.current.show(
                    new NotificacionEntity(
                      "Error desconocido",
                      "Ocurrió un error inesperado.",
                      "rojo",
                      10
                    )
                  );
                  break;
              }
            });
          default:
            notificacionRef.current.show(
              new NotificacionEntity(
                "Error desconocido",
                "Ocurrió un error inesperado.",
                "rojo",
                10
              )
            );
            break;
        }
      })
      .then((result) => {
        if (result) {
          notificacionRef.current.show(
            new NotificacionEntity(
              "Éxito",
              "Se ha enviado un enlace de restablecimiento de contraseña a tu correo.",
              "verde",
              15
            )
          );
        }
      })
      .catch((error) => {
        notificacionRef.current.show(
          new NotificacionEntity(
            "Error de red",
            "No se pudo conectar con el servidor.",
            "rojo",
            10
          )
        );
      });
  };

  if (!vIsEnviarCorreo) {
    return null;
  }

  return (
    <div class="box-modals-publico">
      <div data-figma-id="975:13543" class="olvidaste-contra">
        <div data-figma-id="975:13421" class="olvidaste-contra-info-1">
          <div data-figma-id="975:13422" class="olvidaste-contra-titulos">
            <p data-figma-id="975:13423" class="olvidaste-contra-titulo-1">
              ¿Tienes problemas para acceder a tu cuenta?
            </p>
            <p data-figma-id="975:13424" class="olvidaste-contra-titulo-2">
              Ingresa tu correo electrónico
            </p>
            <p data-figma-id="975:13425" class="olvidaste-contra-titulo-3">
              Te enviaremos un enlace para que cambies tu contraseña
            </p>
          </div>
          <div data-figma-id="975:13427" class="olvidaste-contra-info">
            <div data-figma-id="975:13534" class="correo-10">
              <p data-figma-id="975:13535" class="correo-titulo-3">
                Correo Electrónico
              </p>

              <input
              id="modal_publico"
                type="email"
                value={correo}
                onChange={(e) => setEmail(e.target.value)}
                className="correo-ejemplo-3"
                placeholder="ejemplo@ejem.ej"
                onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
              />

            </div>
              
            <div data-figma-id="975:13429" class="olvidaste-contra-botones">
              <div
                data-figma-id="975:13537"
                class="boton-regresar-2"
                onClick={() => mActivar_DesactivarModal("", false)}
              >
                <p data-figma-id="975:13538" class="boton-cancelar-texto-2">
                  Regresar al inicio
                </p>
              </div>
              <button
                onClick={handleSubmit}
                className="boton-enviar-enlace"
                style={
                  vIsCargandoResp
                    ? { cursor: "wait", backgroundColor: "#37888De6" }
                    : {}
                }
              >
                {vIsCargandoResp ? (
                  <ThreeDots
                    height="30"
                    width="30"
                    color="#fff"
                    radius="1"
                    ariaLabel="three-dots-loading"
                  />
                ) : (
                  <p data-figma-id="975:13540" class="boton-login-texto">
                    Enviar enlace
                  </p>
                )}
              </button>
            </div>
          </div>
          <NotificacionAuth
            ref={notificacionRef} // Usando la referencia
          />
        </div>
        <div data-figma-id="975:13433" class="olvidaste-contra-info-2">
          <div data-figma-id="975:13434" class="frame-1">
            <div data-figma-id="933:13469" class="login-cita">
              <p data-figma-id="933:13470" class="cita-comillas">
                “
              </p>
              <p data-figma-id="975:13437" class="cita-texto">
                La educación es el arma más poderosa que puedes usar para
                cambiar el mundo
              </p>
              <p data-figma-id="975:13438" class="cita-autor">
                - Nelson Mandela
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
